import { selectedTimeAtom } from "@/api/atoms";
import { useDetectOutsideClick } from "@/hooks/useDetectOutsideClick";
import { UilAngleDown } from "@iconscout/react-unicons";
import { useAtom } from "jotai";
import { useRef } from "react";

const items = [
  {
    id: 1,
    value: "2020",
  },
  {
    id: 2,
    value: "2021",
  },
  {
    id: 3,
    value: "2022",
  },
  {
    id: 4,
    value: "2023",
  },
  {
    id: 5,
    value: "2024",
  },
  {
    id: 6,
    value: "2025",
  },
  {
    id: 7,
    value: "last reported",
  },
];

export const TimeDropdown = () => {
  const dropdownRef = useRef(null);
  const [selectedTime, setSelectedTime] = useAtom(selectedTimeAtom);
  const [isActive, setIsActive] = useDetectOutsideClick(dropdownRef, false);

  const onClick = () => setIsActive(!isActive);
  const onSelected = (id: number) => {
    setSelectedTime(id);
    setIsActive(false);
  };

  return (
    <div ref={dropdownRef} className="relative z-10 max-w-[160px]">
      <button
        onClick={onClick}
        className="flex h-8 cursor-pointer items-center justify-between rounded py-0.5 pl-4 text-xs font-semibold capitalize text-white"
      >
        <span>{items.filter((el) => el.id === selectedTime)[0].value}</span>
        <UilAngleDown
          className={`transform transition-all duration-200 ${isActive ? "rotate-180" : ""}`}
        />
      </button>
      <aside
        className={`absolute left-1/2 z-50 w-[120px] -translate-x-1/2 rounded bg-gray-600 bg-opacity-80 text-xs text-white shadow-sm transition-all duration-200 ${
          isActive ? "top-11 opacity-100" : "pointer-events-none top-8 select-none opacity-0"
        }`}
      >
        <ul>
          {items
            .filter((item) => selectedTime !== item.id)
            .map((item) => (
              <li
                key={item.id}
                className="block cursor-pointer px-4 py-2 text-xs capitalize transition-all duration-200 hover:bg-gray-600 hover:bg-opacity-80"
                onClick={() => onSelected(item.id)}
              >
                {item.value}
              </li>
            ))}
        </ul>
      </aside>
    </div>
  );
};
